module.exports = __webpack_public_path__ + "img/HAZOP_flow-min.d49eb8f9.png";